import { TextBody, TextCaption } from '@/design-system/components/typography';
import { UploadDocument } from '@/design-system/components/uploadDocument/UploadDocument';
import { SxProp, View } from 'dripsy';
import * as DocumentPicker from 'expo-document-picker';
import React from 'react';
import { useTranslation } from 'react-i18next';

export interface UploadWebComponentProps {
  sx?: SxProp;
  documentCallback: (file: DocumentPicker.DocumentResult) => void;
}

export const UploadWebComponent: React.FC<UploadWebComponentProps> = ({ sx, documentCallback }) => {
  const { t } = useTranslation('global-bill-payment');

  const documentSelected = async (document: undefined | DocumentPicker.DocumentResult) => {
    if (!!document && document.type === 'success' && !!document.file) {
      documentCallback(document);
    }
  };

  return (
    <View sx={{ ...sxStyles.container, ...sx }}>
      <View sx={sxStyles.leftComponent}>
        <View sx={{ ...sxStyles.number, ...{ borderRadius: '$radius8' } }}>
          <TextBody sx={sxStyles.textNumber}>1</TextBody>
        </View>
        <TextCaption semiBold={true}>{t('global-bill-payment::instruction.text--please-upload')}</TextCaption>
        <TextCaption sx={sxStyles.marginTop8}>{t('global-bill-payment::instruction.text--bill-should-include')}</TextCaption>
        <TextCaption sx={sxStyles.marginTop4}>{`\u2022 ${t('global-bill-payment::glossary.name-of-payee')}`}</TextCaption>
        <TextCaption sx={sxStyles.marginTop4}>{`\u2022 ${t('global-bill-payment::glossary.merchant-bank-name')}`}</TextCaption>
        <TextCaption sx={sxStyles.marginTop4}>{`\u2022 ${t('global-bill-payment::glossary.bill-bank-account-number')}`}</TextCaption>
        <TextCaption sx={sxStyles.marginTop4}>{`\u2022 ${t('global-bill-payment::glossary.bill-amount')}`}</TextCaption>
        <TextCaption sx={sxStyles.marginTop4}>{`\u2022 ${t('global-bill-payment::glossary.other-payment-detail')}`}</TextCaption>
      </View>
      <View sx={sxStyles.space} />
      <View sx={sxStyles.rightComponent}>
        <UploadDocument
          title={t('global-bill-payment::instruction.text--drag-your-file')}
          instructions={t('global-bill-payment::instruction.text--make-sure-clearly-visible')}
          successUploadedInstructions={t('global-bill-payment::instruction.text--intro-after-upload')}
          onValueChange={documentSelected}
          sx={sxStyles.uploadDocument}
          isLoading={false}
          isUploadSuccess={true}
          type={['image/png', 'image/jpeg', 'application/pdf']}
        />
      </View>
      <View sx={sxStyles.space} />
    </View>
  );
};

const sxStyles: Record<string, SxProp> = {
  container: {
    backgroundColor: 'transparent',
    flexDirection: 'row',
    width: '100%'
  },
  leftComponent: {
    flex: 29,
    py: '$1',
    pl: '$8',
    pr: '$1',
    flexDirection: 'column'
  },
  rightComponent: {
    flex: 52,
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center'
  },
  number: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '$6',
    height: '$6',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '$secondary'
  },
  textNumber: {
    color: '$white'
  },
  space: {
    flex: 4
  },
  uploadDocument: {
    width: '100%',
    height: 350
  },
  marginTop4: {
    mt: '$1'
  },
  marginTop8: {
    mt: '$2'
  }
};
